<template>
  <div class="reports panel">
    <el-container>
      <el-header>
        <h2 class="card-title">Reports</h2>
      </el-header>
      <el-main>
        <el-table
          :data="tableData"
          :default-sort = "{prop: 'name', order: 'ascending'}"
          style="width: 100%">
          <el-table-column
            prop="name"
            label="Name"
            sortable
            width="180"
            >
          </el-table-column>
          <el-table-column
            prop="last_week"
            label="Last Week"
            sortable
            width="180"
          >
          </el-table-column>
          <el-table-column
            prop="this_week"
            label="This Week"
            sortable
            width="180"
          >
          </el-table-column>
          <el-table-column
            prop="timer_status"
            label="Timer Status"
            sortable
            width="180"
          >
          </el-table-column>
          <el-table-column
            prop="current_client"
            label="Current Client"
            sortable
            width="240"
          >
          </el-table-column>
          <el-table-column
            prop="current_project"
            label="Current Project"
            sortable
            width="360"
          >
          </el-table-column>
          <el-table-column
            prop="current_task"
            label="Current Task"
            sortable
            width="180"
          >
          </el-table-column>
        </el-table>
      </el-main>
    </el-container>
  </div>
</template>

<script>
  import moment from 'moment'
  import { mixin as LogTimes } from '../../mixins/LogTimes'

  export default {
    name: 'reports',
    mixins: [LogTimes],
    data () {
      return {
        activeTasks: [],
        shouldLoadData: true,
        // userTasksData: [],
        startDateLastWeek: moment().subtract(1, 'week').day(1).hour(0).minute(0).second(0).utc(),
        endDateLastWeek: moment().subtract(1, 'week').day(7).hour(23).minute(59).second(59).utc(),

        startDateThisWeek: moment().day(1).hour(0).minute(0).second(0).utc(),
        endDateThisWeek: moment().day(7).hour(23).minute(59).second(59).utc()
      }
    },
    watch: {
      // When the route is programatically changed (e.g. when a different user is selected)
      // the route 'user_id' param (this.userId) will change.
      // Re-init the Component's data when this happens
      'tasksActive'() {
        this.getTasksHandler()
      }
    },
    methods: {
      setPageTitle () {
        this.$store.dispatch('setPageTitle', 'Reports')
      },
      getTasksHandler(){
        if(this.users && this.shouldLoadData){
          for (let i in this.users) {
            if (this.users[i].status === 0) {
              continue // Ignore inactive users
            }
            // console.log('this.',i)
            // Add timeout to call the API, wait 1/2 second before it goes to next
            setTimeout(() => {
              // console.log('DISPATING')
              this.$store.dispatch('getTasksActive', {user_id: i})
            }, 500)
          }
        }
        // only get tasks when page fist load, otherwise it will keep looping forever..
        this.shouldLoadData = false
        // this.$store.dispatch('getTasksActive', {user_id: "10"})
        // this.$store.dispatch('getTasks', {user_id: "10"})
        // console.log('this.shouldLoadData', this.shouldLoadData)
      },
      // Nav handling
      gotoClient () {
        this.$router.push({name: 'client', params: { client_id: this.project.client_id }})
      },
      gotoUser (userId) {
        this.$router.push({name: 'user', params: { user_id: userId }})
      },
      getLastWeekLogs () {
        let query = {
          'start': this.startDateLastWeek.toISOString(),
          'end': this.endDateLastWeek.toISOString()
        }
        this.$store.dispatch('getLogs', query)
      },
      getThisWeekLogs () {
        let query = {
          'start': this.startDateThisWeek.toISOString(),
          'end': this.endDateThisWeek.toISOString()
        }
        this.$store.dispatch('getLogs', query)
      }
    },
    computed: {
      tableData () {
        // Build the list of User Data for final output
        let users = {}
        for (let i in this.users) {
          if (this.users[i].status === 0) {
            continue // Ignore inactive users
          }
          users[i] = {
            name: this.users[i].first_name + ' ' + this.users[i].last_name,
            last_week: 0,
            this_week: 0
          }
        }

        // Sort all logs within the two time ranges into user groups
        Object.keys(this.logs).map((k) => {
          if (this.logs[k].end !== null && users[this.logs[k].user_id] !== undefined) { // Ignore running logs
            let logTimestamp = moment.utc(this.logs[k].end).unix()
            if (logTimestamp >= this.startDateLastWeek.unix() && logTimestamp <= this.endDateLastWeek.unix()) {
              users[this.logs[k].user_id].last_week += (this.logTimeInSeconds(this.logs[k]) / 60 / 60)
            } else if (logTimestamp >= this.startDateThisWeek.unix() && logTimestamp <= this.endDateThisWeek.unix()) {
              users[this.logs[k].user_id].this_week += (this.logTimeInSeconds(this.logs[k]) / 60 / 60)
            }
          }
        })

        // add current task to user
        // console.log('actives', this.tasksActive)
        for(let i in users){
          users[i]['timer_status'] = 'OFF'
          users[i]['current_client'] = '-'
          users[i]['current_project'] = '-'
          users[i]['current_task'] = '-'
          for(let task in this.tasksActive){
            if(parseInt(this.tasksActive[task].user_id) === parseInt(i)){
              users[i]['current_task'] = this.tasksActive[task]
              users[i]['timer_status'] = 'ON'
              users[i]['current_client'] = this.tasksActive[task].client_name
              users[i]['current_project'] = this.tasksActive[task].project_name
              users[i]['current_task'] = this.tasksActive[task].title
            }
          }
        }
        // console.log('activeTasks', activeTasks)
        // console.log('users', users)

        return Object.keys(users).map((k) => {
          users[k].last_week = Math.round(users[k].last_week)
          users[k].this_week = Math.round(users[k].this_week)
          return users[k]
        }).sort((a, b) => {
          return (a.name < b.name) ? -1 : 1
        })
      },

      // Vuex Mappings
      projects () {
        return this.$store.state.projects.objects
      },
      tasks () {
        return this.$store.state.tasks.objects
      },
      tasksActive () {
        // console.log('this.$store.state.tasks.objectsActive', this.$store.state.tasks.objectsActive)
        return this.$store.state.tasks.objectsActive
      },
      logs () {
        return this.$store.state.logs.objects
      },
      users () {
        return this.$store.state.users.objects
      },
      userTasks () {
        // Return all logs related to the current user, that happened today
        var tasks = []
        if (this.user) {
          tasks = Object.keys(this.tasks).map((k) => this.tasks[k]).filter(function (item) {
            // Only return tasks belonging to the current user, that aren't complete (1) or cancelled (6)
            if (item.group_task) {
              return item.group_users.indexOf(this.user.id) !== -1 && item.status !== 1 && item.status !== 6
            } else {
              return (item.user_id === this.user.id && item.status !== 1 && item.status !== 6)
            }
          }.bind(this))
        }
        return tasks
      },
    },
    created () {
      this.getTasksHandler()
    },
    mounted () {
      // Note: Intentionally not calling store.getUsers as this is handled on load in App.vue
      // and Pusher should take care of live-updates to users
      this.$store.dispatch('setPageTitle', 'Reports')
      this.getLastWeekLogs()
      this.getThisWeekLogs()
      this.getTasksHandler()
    }
  }
</script>

<style lang="less" rel="stylesheet/less" scoped>
  .reports {

  }
</style>
